import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Category } from "../../categories.types";
import { requestCreateSubChildCategory } from "./createSubChildCategory.request";

const useCreateSubChildCategory = (
  options?: MutationOptions<Category, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateSubChildCategory,
    onError: toastServerError,
    ...options
  });
};

export default useCreateSubChildCategory;
